exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.knowme-mobile[data-v-12608fe8] {\n    position: fixed;\n    left: 10px;\n    bottom: 10px;\n}\n.knowme-mobile img[data-v-12608fe8] {\n    width: 70%;\n}\n.knowme-mobile a[data-v-12608fe8]:hover {\n    opacity: 70%;\n}\n.knowme-pc[data-v-12608fe8] {\n    padding-top: 50px;\n}\n.knowme-pc .fixed[data-v-12608fe8] {\n    position: fixed;\n    right: 10px;\n    top: 10px;\n}\n.knowme-pc img[data-v-12608fe8] {\n    width: 400px;\n}\n.knowme-pc a[data-v-12608fe8]:hover {\n    opacity: 70%;\n}\n", ""]);

// exports
